module.exports = __webpack_public_path__ + "img/classiccar-1.6cdaf893.webp";